import AdminCalendar from './AdminCalendar/AdminCalendar.jsx';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../context/AuthContext';
import { toast } from '../../common/Toast/toast';

const Calendar = () => {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const hasShownToast = useRef(false);

  useEffect(() => {
    const canView = hasPermission('student-calendar', 'view', 'lms');
    if (!canView && !hasShownToast.current) {
      toast.error('You do not have permission to access calendar.');
      hasShownToast.current = true;
      navigate('/');
    }
  }, [hasPermission, navigate]);

  /* The student calendar, whoever opens it. Staff land on a gate
     that asks which student first -- see AdminCalendar's
     `needsStudentPick`. Without this prop the page cannot tell a
     student's own calendar from the whole institution's, because an
     admin reading a student's calendar is in admin mode either way. */
  return <AdminCalendar audience="student" />;
};

export default Calendar;
